import { useAuth } from '@/contexts/AuthContext';
import { RegisterGate } from '@/components/RegisterGate';
import BrandedSplash from '@/components/BrandedSplash';

/**
 * Route guard for creation flows that should be *previewable* by logged-out
 * visitors. Authenticated users get the flow as usual. Logged-out visitors
 * see the real flow dimmed in the background (≈60% transparent) with a
 * registration overlay in front. After they register, the route reloads and
 * the flow appears clearly.
 */
export default function GatedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <BrandedSplash />;

  if (user) return children;

  return (
    <div className="relative min-h-screen" data-testid="gated-flow">
      <div className="pointer-events-none select-none opacity-40 blur-[2px]" aria-hidden="true">
        {children}
      </div>
      <RegisterGate />
    </div>
  );
}
